import { DictionaryService } from '../../services/dictionary.service';

import {
  iconoirBellNotification,
  iconoirBookStack,
  iconoirBoxIso,
  iconoirCalendar,
  iconoirClipboardCheck,
  iconoirDatabaseExport,
  iconoirDatabaseScriptPlus,
  iconoirGroup,
  iconoirHandbag,
  iconoirHomeSimple,
  iconoirLogOut,
  iconoirMail,
  iconoirMap,
  iconoirMegaphone,
  iconoirMultiBubble,
  iconoirPageEdit,
  iconoirPenTablet,
  iconoirReportColumns,
  iconoirCart,
  iconoirUserBadgeCheck,
} from '@ng-icons/iconoir';

export const routes = (
  permittedRoutes: string[],
  dictionary: DictionaryService,
  returnAll: boolean = false,
) =>
  [
    {
      name: dictionary.get('Dashboard'),
      icon: 'iconoirHomeSimple',
      path: '/dashboard',
    },
    {
      name: dictionary.get('Sales'),
      icon: 'iconoirCart',
      path: '/sales',
    },
    {
      name: dictionary.get('Users'),
      icon: 'iconoirGroup',
      path: '/users',
    },
    {
      name: dictionary.get('Supervisors'),
      icon: 'iconoirUserBadgeCheck',
      path: '/supervisors',
    },
    {
      name: dictionary.get('PlanDrafts'),
      icon: 'iconoirPageEdit',
      path: '/plan-draft',
    },
    {
      name: dictionary.get('Products'),
      icon: 'iconoirBoxIso',
      path: '/products',
    },
    {
      name: dictionary.get('Customers'),
      icon: 'iconoirHandbag',
      path: '/customers',
    },
    {
      name: dictionary.get('IdBrowser'),
      icon: 'iconoirDatabaseExport',
      path: '/id-browser',
    },
    {
      name: dictionary.get('Evaluations'),
      icon: 'iconoirClipboardCheck',
      path: '/evaluations',
    },
    {
      name: dictionary.get('Reports'),
      icon: 'iconoirDatabaseScriptPlus',
      path: '/adhoc',
    },
    {
      name: dictionary.get('Email'),
      icon: 'iconoirMail',
      path: '/email',
    },
    {
      name: dictionary.get('Intelligence'),
      icon: 'iconoirReportColumns',
      path: '/intelligences',
    },
    {
      name: dictionary.get('Samples'),
      icon: 'iconoirBookStack',
      path: '/samples',
    },
    {
      name: dictionary.get('Regions'),
      icon: 'iconoirMap',
      path: '/regions',
    },
    {
      name: dictionary.get('Promoters'),
      icon: 'iconoirMegaphone',
      path: '/promoters',
    },
    {
      name: dictionary.get('LeaveManagement'),
      icon: 'iconoirPenTablet',
      path: '/leave-management',
    },
    {
      name: dictionary.get('CustomerService'),
      icon: 'iconoirMultiBubble',
      path: '/customer-service',
    },
    {
      name: dictionary.get('Notifications'),
      icon: 'iconoirBellNotification',
      path: '/notifications',
    },
  ].filter(
    (route) =>
      permittedRoutes.includes(route.path.replace('/', '')) || returnAll,
  );

export const routesIcons = {
  iconoirLogOut,
  iconoirCalendar,
  iconoirHomeSimple,
  iconoirGroup,
  iconoirPageEdit,
  iconoirBoxIso,
  iconoirHandbag,
  iconoirDatabaseExport,
  iconoirClipboardCheck,
  iconoirDatabaseScriptPlus,
  iconoirMail,
  iconoirReportColumns,
  iconoirCart,
  iconoirUserBadgeCheck,
  iconoirBookStack,
  iconoirMap,
  iconoirMegaphone,
  iconoirPenTablet,
  iconoirMultiBubble,
  iconoirBellNotification,
};
